import React from 'react';
import css from './css.module.less';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import { Form, OriNumberInput, OriCheckbox } from 'src/components/Antd';
import Section from 'src/pages/SalesCannelVersion/Components/SectionContainer';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import { isNumber } from 'src/tools/helper';
import Tip from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/DiscountLastExpression';
import { get } from 'lodash';
import ProductsApplyToRadioAndTable from 'src/pages/StoreVoucher/Detail/Components/ProductsApplyToRadioAndTable';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { last4Precision } from 'src/tools/regExp';

const Item = Form.Item;
const _base = 'applyTo';
const _discountValue = ['voucherMethod', 'percentage'];
const _discountApplyTo = [_base, 'conditionType'];
const _products = [_base, 'products'];
const _enabledMaxAmount = [_base, 'maximumEnabled'];
const _maxAmount = [_base, 'maximumPerVoucher'];

const PercentageOff = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { currency = 'HKD', disabled } = props;
  return (
    <SectionWrapper title={getI18n('voucher.storeVoucherDetail.discountValue')}>
      <Section bottomBorder className={css.innerSection}>
        <Row
          elements={[
            {
              child: (
                <ItemWrapper
                  title={`${getI18n(
                    'voucher.storeVoucherDetail.voucherValue',
                  )}*`}>
                  <Item
                    name={_discountValue}
                    rules={[
                      {
                        validator: async (x, value) => {
                          if (!isNumber(value)) {
                            return Promise.reject(
                              new Error(getI18n('general.pleasefillthisfield')),
                            );
                          }
                          if (value < 1) {
                            return Promise.reject(
                              new Error(
                                getI18n(
                                  'voucher.storeVoucherDetail.valueshouldbenolessthan1',
                                ),
                              ),
                            );
                          }
                          if (value > 99) {
                            return Promise.reject(
                              new Error(
                                getI18n(
                                  'voucher.storeVoucherDetail.valueshouldbenogreaterthan99',
                                ),
                              ),
                            );
                          }
                          if (!last4Precision.test(value)) {
                            return Promise.reject(
                              new Error(getI18n('general.fourDecimal')),
                            );
                          }
                        },
                      },
                    ]}>
                    <OriNumberInput
                      size='large'
                      max={99}
                      suffix={'%'}
                      disabled={disabled}
                    />
                  </Item>
                </ItemWrapper>
              ),
            },
            { child: <React.Fragment /> },
          ]}
        />
      </Section>
      <Section bottomBorder className={css.productSection}>
        <ProductsApplyToRadioAndTable
          radioName={_discountApplyTo}
          tableName={_products}
          tableId={'StoreVoucherPercentageOff'}
          disabled={disabled}
        />
      </Section>
      <Section bottomBorder className={css.generalSection}>
        <Item name={[_base, 'flashSaleExcluded']} valuePropName={'checked'}>
          <OriCheckbox disabled={disabled}>
            {getI18n('voucher.storeVoucherDetail.excludeflashsaleitems')}
          </OriCheckbox>
        </Item>
      </Section>
      <Section bottomBorder className={css.generalSection}>
        <Item name={_enabledMaxAmount} valuePropName={'checked'}>
          <OriCheckbox disabled={disabled}>
            {getI18n(
              'voucher.storeVoucherDetail.setamaximumdiscountamountperorder',
            )}
          </OriCheckbox>
        </Item>
        <Item
          shouldUpdate={(p, c) => {
            const pV = get(p, _enabledMaxAmount);
            const cV = get(c, _enabledMaxAmount);
            return pV !== cV;
          }}>
          {({ getFieldValue }) => {
            const checked = getFieldValue(_enabledMaxAmount);
            if (checked) {
              return (
                <div className={css.maxContainer}>
                  <Item
                    className={css.maxAmount}
                    name={_maxAmount}
                    rules={[
                      {
                        validator: async (x, value) => {
                          if (!isNumber(value)) {
                            return Promise.reject(
                              new Error(getI18n('general.pleasefillthisfield')),
                            );
                          }
                          if (value < 1) {
                            return Promise.reject(
                              new Error(
                                getI18n(
                                  'voucher.storeVoucherDetail.valueshouldbenolessthan1',
                                ),
                              ),
                            );
                          }
                        },
                      },
                    ]}>
                    <OriNumberInput
                      disabled={disabled}
                      size='large'
                      suffix={currency}
                    />
                  </Item>
                </div>
              );
            }
            return null;
          }}
        </Item>
      </Section>
      <Tip
        title={getI18n('voucher.storeVoucherDetail.discountCalculationrule')}
        content={getI18n(
          'voucher.storeVoucherDetail.discountCalculationrulecontent',
        )}
        overlayDescription={getI18n(
          'voucher.storeVoucherDetail.discountCalculationruledesc',
        )}
      />
    </SectionWrapper>
  );
};
export default PercentageOff;
